import script from "./blends-section.vue?vue&type=script&setup=true&lang=js"
export * from "./blends-section.vue?vue&type=script&setup=true&lang=js"

import "./blends-section.vue?vue&type=style&index=0&id=2257aaa3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2257aaa3"]])

export default __exports__